import { typographyStyles, constants } from "@newsela/angelou";

const { heading6Obj, fontFamily, fontSize } = typographyStyles;
const { circular } = fontFamily;

const greyDark = constants.colors.ui.neutral[600];
const grey = constants.colors.ui.neutral[400];

export const dateTimeSelectorLoadingWrapperCss = {
  width: "100%",
  height: "48px",
  marginTop: "22px",
};

export const dateTimeSelectorCSS = [
  {
    marginTop: "3px",
    display: "flex",
    flexDirection: "column",
  },
  {
    label: {
      ...fontSize.textS,
      color: greyDark,
      fontFamily: circular,
      heading6Obj,
      fontWeight: "bold",
      marginBottom: ".25rem",
    },
  },
];

export const dateTimeSelectorInputCss = [
  {
    fontSize: "1rem",
    lineHeight: "1.5",
    padding: "0.6em",
    borderRadius: "4px",
    border: `1px ${grey} solid`,
  },
  fontFamily.circular,
];

export const popOutCss = {
  root: { zIndex: 3 },
};
